/**
 * The correspondent list behind the sizers' correspondent picker.
 *
 * Why every sizer needs one (pricing-scenario-sizers.md, shipping requirement
 * 5): `correspondentId` is what makes a scenario correspondent-aware. On the
 * RTL/GUC side it resolves the account RATE SPREAD (`rate.accountSpread`); on
 * the DSCR side it resolves the MARGIN IN BOND POINTS
 * (`result.marginPointsApplied`) by exactly the rule the lock uses — override >
 * tier + additional. Without it every scenario prices at base, which is not the
 * number the correspondent will be quoted.
 *
 * `GET /correspondents/list` returns rows shaped `{_id|id, companyName}`.
 */
import { useEffect, useState } from "react";

import { dsHttp } from "../../lib/digitalSizerHttp";

export default function useSizerCorrespondents() {
  const [correspondents, setCorrespondents] = useState([]);

  useEffect(() => {
    let live = true;
    dsHttp
      .get("/correspondents/list")
      .then((r) => {
        if (!live) return;
        setCorrespondents(
          (r.data || [])
            .map((c) => ({ value: c._id ?? c.id, label: c.companyName || "" }))
            .filter((c) => c.value && c.label),
        );
      })
      // The picker is optional — a scenario prices at base without it, so a
      // failed list must never block the form.
      .catch(() => live && setCorrespondents([]));
    return () => {
      live = false;
    };
  }, []);

  return correspondents;
}
